
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
/**
 * @Description: 菜单
 * @author gan
 * @date: 2020/12/17 11:09
 * @attribute name 名称
 * @attribute path 路径
 * @attribute icon 图标
 * @attribute children 子菜单
 * @attribute menuKey 菜单key(需要唯一，用于获取权限)
 */
import store from "@/store/store";
import {commonLocalStorage, handleCommonMenuData} from "@/utils/common";

// 生成基础菜单结构，后续再根据最新配置做菜单隐藏处理。
const createBaseMenuList = () => [
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'),
    icon: '&#xe67b;',
    path: '/statistics',
    menuKey: 'supplier_statistics',
    type: 'statistics',
    hideCrumbs: true, // 隐藏面包屑
    guidanceModule: false, // 指引模块（默认开启）  true：开启指引模块    false  不开启指引模块
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007960'),
    icon: '&#xe668;',
    type: 'supplierOrder',
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007961'),
        path: '/collectionOrderList',
        menuKey: 'supplier_collectionOrderList',
        guidanceModule: true
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007962'),
        path: '/directDeliveryOrderList',
        menuKey: 'supplier_directDeliveryOrderList',
        guidanceModule: true
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005610'),
        path: '/stockList',
        menuKey: 'supplier_stockList',
        guidanceModule: true,
        children: [
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006862'),
            path: '/initiateStocking',
            menuKey: 'supplier_initiateStocking',
            menuHide: true // 菜单不展示
          },
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007963'),
            path: '/stockOrderDetails',
            menuKey: 'supplier_stockOrderDetails',
            menuHide: true // 菜单不展示
          }
        ]
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007964'),
        path: '/shipmentRecord',
        menuKey: 'supplier_shipmentRecord',
        guidanceModule: true,
        children: [
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007965'),
            path: '/shipmentRecordDetails',
            menuKey: 'supplier_shipmentRecordDetails',
            menuHide: true // 菜单不展示
          },
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006819'),
            path: '/additionalGoods',
            menuKey: 'supplier_additionalGoods',
            menuHide: true // 菜单不展示
          }
        ]
      }
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007966'),
    icon: '&#xe678;',
    type: 'productCenter',
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006967'),
        path: '/productCenter/productGoods',
        menuKey: 'supplier_productCenter_productGoods',
        guidanceModule: true,
        children: [
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003337'),
            path: '/supplierViewSku',
            menuKey: 'supplier_viewSku',
            menuHide: true // 菜单不展示
          },
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007967'),
            path: '/productDetails',
            menuKey: 'supplier_productDetails',
            menuHide: true // 菜单不展示
          },
          {
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006989'),
            path: '/collectProducts',
            menuKey: 'supplier_collectProducts',
            menuHide: true // 菜单不展示
          },
        ]
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007968'),
        path: '/productCenter/productBrand',
        menuKey: 'supplier_productCenter_productBrand',
        guidanceModule: true,
      }
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007969'),
    icon: '&#xe6a6;',
    type: 'warehouseLogistics',
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007931'),
        path: '/supplierWarehouseManage',
        menuKey: 'supplier_supplierWarehouseManage',
        guidanceModule: true,
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007928'),
        path: '/supplierLogisticsManage',
        menuKey: 'supplier_supplierLogisticsManage',
        guidanceModule: true,
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007970'),
        path: '/warehouseCostAllocation',
        menuKey: 'supplier_warehouseCostAllocation',
        guidanceModule: true,
      }
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007971'),
    icon: '&#xe68c;',
    type: 'platformAuthorization',
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007972'),
        path: '/platformAuthorization',
        menuKey: 'supplier_platformAuthorization',
        guidanceModule: true,
      }
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007937'),
    path: '/addressLibraryManageList',
    menuKey: 'supplier_addressLibraryManageList',
    icon: '&#xe6af;',
    type: 'addressLibraryManage',
    guidanceModule: true
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007973'),
    path: '/reconciliationManage',
    menuKey: 'supplier_reconciliationManage',
    icon: '&#xe665;',
    type: 'reconciliationManage',
    guidanceModule: true,
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004377'),
        path: '/reconciliationBillDetails',
        menuKey: 'supplier_reconciliationBillDetails',
        menuHide: true // 菜单不展示
      }
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000037'),
    path: '/messageCenter',
    menuKey: 'supplier_messageCenter',
    jurisdictionHide: true, // 不需要权限判断
    icon: '&#xe8be;',
    type: 'messageCenter',
    guidanceModule: true,
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007955'),
        path: '/messageMailboxes',
        menuKey: 'supplier_messageMailboxes',
        menuHide: true // 菜单不展示
      },
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007974'),
    icon: '&#xe6e3;',
    type: 'accountManage',
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
        path: '/accountManage/basicInformation',
        menuKey: 'supplier_accountManage_basicInformation',
        guidanceModule: true,
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007956'),
        path: '/accountManage/management',
        menuKey: 'supplier_accountManage_management',
        guidanceModule: true,
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004294'),
        path: '/accountManage/collectionAccount',
        menuKey: 'supplier_accountManage_collectionAccount',
        guidanceModule: true,
      }
    ]
  },
  {
    name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007957'),
    icon: '&#xe664;',
    type: 'importExportTask',
    children: [
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007958'),
        path: '/importTask',
        menuKey: 'supplier_importTask'
      },
      {
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007959'),
        path: '/exportTask',
        menuKey: 'supplier_exportTask'
      }
    ]
  }
];

export const getSupplierMenu = () => {
  let supplierMenuList = createBaseMenuList();
  const configurationItemInfo = commonLocalStorage.getItem('configurationItemInfo') ?? store.state.configurationItemInfo;
  
  // 停用所有供应商第三方平台时，不显示【供应商--平台授权】菜单
  const supplierPlatformSetDisabled = configurationItemInfo?.suppliePlatformSet?.length <= 0 ?? true;
  if (supplierPlatformSetDisabled) {
    supplierMenuList = handleCommonMenuData(supplierMenuList, {
      hideMenuKeys: ['supplier_platformAuthorization'],
      hideTypes: ['platformAuthorization']
    });
  }
  
  return supplierMenuList;
};

export default {
  get menu() {
    return getSupplierMenu();
  }
};
